import { render, staticRenderFns } from "./ItemsController.vue?vue&type=template&id=7f1e3479&scoped=true"
import script from "./ItemsController.vue?vue&type=script&lang=js"
export * from "./ItemsController.vue?vue&type=script&lang=js"
import style0 from "./ItemsController.vue?vue&type=style&index=0&id=7f1e3479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1e3479",
  null
  
)

export default component.exports